import Model from "../../generic/Model";

export default class Distributor extends Model {
  static path = "distributors";
}
